<!-- us-sales-tax-report.component.html -->
<div class="container-fluid">
  <!-- Page Header with Utility Buttons -->
  <div class="d-flex flex-column flex-lg-row justify-content-lg-between align-items-start align-items-lg-baseline mb-3">
    <h1 class="page-header mb-2 mb-lg-0">Tax Report</h1>

    <!-- Utility Buttons -->
    <div class="d-flex align-items-center" style="margin-top: 0.5rem;">
      <button style="background-color: transparent !important; border: none;"
        (click)="onPrint()"
        type="button"
        mat-icon-button
        class="me-1 mb-1"
        matTooltip="Print tax report"
        matTooltipPosition="below"
        aria-label="Print tax report">
        <mat-icon style="color: #1C3F8B;">print</mat-icon>
      </button>
      <button (click)="exportCSV()"
        color="primary"
        mat-flat-button
        class="me-1 mb-1 warning">
        <mat-icon>file_download</mat-icon>
        <span>Export</span>
      </button>
    </div>
  </div>

  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title>
        Filter
      </mat-panel-title>
      <mat-panel-description>
        <app-filter-results-panel [parameters]=queryParams></app-filter-results-panel>
      </mat-panel-description>
    </mat-expansion-panel-header>
    <form (ngSubmit)="onSubmit(f)" #f=ngForm class="form">
      <div class="row">
        <div class="col-12 col-sm-6 col-lg">
          <mat-form-field class="full-width-field">
            <mat-label>Date Range</mat-label>
            <input #dateRangeInput matInput
                   [value]="dateRangeDisplayValue"
                   placeholder="Select date range"
                   readonly
                   name="dateRange">
            <button matSuffix mat-icon-button type="button" (click)="openDateRangePicker()">
              <mat-icon>calendar_today</mat-icon>
            </button>
          </mat-form-field>
        </div>

        <div class="col-12 col-sm-6 col-lg">
          <mat-form-field class="full-width-field">
            <mat-label>Tax Type</mat-label>
            <mat-select name="tax_type" [(ngModel)]="taxTypeFilter" (selectionChange)="onFilterChange()" multiple>
              <mat-option *ngFor="let type of availableTaxTypes" [value]="type">
                {{ taxTypeLabel(type) }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="col-12 col-sm-6 col-lg">
          <mat-form-field class="full-width-field">
            <mat-label>Payment Type</mat-label>
            <mat-select name="payment_type" [(ngModel)]="paymentTypeFilter" (selectionChange)="onFilterChange()" multiple>
              <mat-option *ngFor="let type of availablePaymentTypes" [value]="type.id">
                {{ type.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="col-12 col-sm-6 col-lg">
          <mat-form-field class="full-width-field">
            <mat-label>Status</mat-label>
            <mat-select name="status" [(ngModel)]="statusFilter" (selectionChange)="onFilterChange()" multiple>
              <mat-option *ngFor="let status of availableStatuses" [value]="status">
                {{ status }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="col-12 col-sm-6 col-lg">
          <mat-form-field class="full-width-field">
            <mat-label>Search</mat-label>
            <input matInput name="search" [(ngModel)]="searchText"
                   placeholder="Student, title or payment ID"
                   (input)="onAutocompleteStudent($event)"
                   (ngModelChange)="onSearchInput()"
                   (keyup.enter)="onFilterChange()"
                   [matAutocomplete]="autoCompleteSearch">
            <button matSuffix mat-icon-button type="button" (click)="onFilterChange()">
              <mat-icon>search</mat-icon>
            </button>
          </mat-form-field>
          <mat-autocomplete #autoCompleteSearch="matAutocomplete"
              (optionSelected)="onFilterChange()">
            <mat-option
                *ngFor="let option of autoCompleteStudentOptions"
                [value]="option.label">
              {{option.label}} ({{option.value}})
            </mat-option>
          </mat-autocomplete>
        </div>

        <div class="col-6 col-sm-3 col-lg">
          <mat-form-field class="full-width-field">
            <mat-label>Min Gross</mat-label>
            <input matInput type="number" name="min_amount" [(ngModel)]="minAmount"
                   (keyup.enter)="onFilterChange()" (change)="onFilterChange()">
          </mat-form-field>
        </div>
        <div class="col-6 col-sm-3 col-lg">
          <mat-form-field class="full-width-field">
            <mat-label>Max Gross</mat-label>
            <input matInput type="number" name="max_amount" [(ngModel)]="maxAmount"
                   (keyup.enter)="onFilterChange()" (change)="onFilterChange()">
          </mat-form-field>
        </div>
        <div class="col-12 col-sm-6 col-lg-auto d-flex align-items-center">
          <mat-slide-toggle name="nonzero_tax" [(ngModel)]="nonzeroTaxOnly" (change)="onFilterChange()">
            Hide $0 tax rows
          </mat-slide-toggle>
        </div>
        <div class="col-12 col-sm-6 col-lg-auto ms-lg-auto d-flex align-items-center justify-content-end">
          <button (click)="resetForm()" color="primary" mat-flat-button mat-button type="button">Clear</button>
        </div>
      </div>
    </form>
  </mat-expansion-panel>

  <mat-progress-bar [class.invisible]="!ShowProgressBar" mode="indeterminate"></mat-progress-bar>

  <!-- Summary totals -->
  <div *ngIf="summary" class="d-flex flex-wrap align-items-baseline gap-4 mt-3">
    <div>
      <span class="text-muted me-1">Total Tax Collected:</span>
      <strong>{{ summary.total_tax_collected | studioCurrency }}</strong>
    </div>
    <div *ngFor="let t of displayTypes">
      <span class="text-muted me-1">{{ taxTypeLabel(t) }} Collected:</span>
      <strong>{{ typeTotal(t) | studioCurrency }}</strong>
    </div>
    <div *ngIf="untrackedNote()" class="text-muted">
      {{ untrackedNote() }}
    </div>
  </div>

  <div class="table-responsive-sticky table-responsive">
    <table mat-table #displayTable [dataSource]="dataSource"
      class="mt-4">

      <ng-container matColumnDef="title">
        <th mat-header-cell *matHeaderCellDef>Title</th>
        <td mat-cell *matCellDef="let element">{{element.title}}</td>
        <td mat-footer-cell *matFooterCellDef class="fw-bold">Totals</td>
      </ng-container>

      <ng-container matColumnDef="field_date_and_time">
        <th mat-header-cell *matHeaderCellDef>Date and Time</th>
        <td mat-cell *matCellDef="let element">{{ reportDateService.formatDateTime(element.field_date_and_time) }}</td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <ng-container matColumnDef="field_gross_tuition">
        <th mat-header-cell *matHeaderCellDef class="text-end">Gross Tuition</th>
        <td mat-cell *matCellDef="let element" class="text-end">{{element.field_gross_tuition | studioCurrency }}</td>
        <td mat-footer-cell *matFooterCellDef class="text-end fw-bold">{{ (summary?.total_gross ?? 0) | studioCurrency }}</td>
      </ng-container>

      <ng-container matColumnDef="field_payment_id">
        <th mat-header-cell *matHeaderCellDef>Payment ID</th>
        <td mat-cell *matCellDef="let element">{{element.field_payment_id}}</td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <ng-container matColumnDef="field_payment_type">
        <th mat-header-cell *matHeaderCellDef>Payment Type</th>
        <td mat-cell *matCellDef="let element">{{element.field_payment_type}}</td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <ng-container matColumnDef="field_status">
        <th mat-header-cell *matHeaderCellDef>Status</th>
        <td mat-cell *matCellDef="let element">{{element.field_status}}</td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <ng-container matColumnDef="field_student_name">
        <th mat-header-cell *matHeaderCellDef>Student Name</th>
        <td mat-cell *matCellDef="let element">{{element.field_student_name}}</td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <ng-container matColumnDef="field_tax_collected">
        <th mat-header-cell *matHeaderCellDef class="text-end">Tax Collected</th>
        <td mat-cell *matCellDef="let element" class="text-end">{{element.field_tax_collected | studioCurrency }}</td>
        <td mat-footer-cell *matFooterCellDef class="text-end fw-bold">{{ (summary?.total_tax_collected ?? 0) | studioCurrency }}</td>
      </ng-container>

      <!-- One column per displayed tax type: the selected types, or every
           type present in the range when nothing is selected. -->
      <ng-container *ngFor="let t of displayTypes" [matColumnDef]="'type_' + t">
        <th mat-header-cell *matHeaderCellDef class="text-end">{{ taxTypeLabel(t) }} Collected</th>
        <td mat-cell *matCellDef="let element" class="text-end">
          {{ element.tax_amounts?.[t] != null ? (element.tax_amounts[t] | studioCurrency) : '-' }}
        </td>
        <td mat-footer-cell *matFooterCellDef class="text-end fw-bold">{{ typeTotal(t) | studioCurrency }}</td>
      </ng-container>

      <ng-container matColumnDef="field_total_payment_amount">
        <th mat-header-cell *matHeaderCellDef class="text-end">Total Payment Amount</th>
        <td mat-cell *matCellDef="let element" class="text-end">{{element.field_total_payment_amount | studioCurrency }}</td>
        <td mat-footer-cell *matFooterCellDef class="text-end fw-bold">{{ (summary?.total_payment_amount ?? 0) | studioCurrency }}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      <tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>
    </table>
  </div>

</div>
